// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cb5daf13","455":"8e972716"}[chunkId] + ".chunk.js";
};